/* eslint-disable ember/classic-decorator-hooks, ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies */
// Extending From
import Controller from '@ember/controller';
// Ember Imports
import { computed } from '@ember/object';
import { service } from '@ember/service';

export default class LoggedOutController extends Controller {
  @service
  session;

  @service
  environment;

  init() {
    super.init(...arguments);

    // Regardless of how we've got here, ensure tokens are purged on loading
    // page. This ensures Single Sign-On (SSO) from FusionAuth is able to clear
    // tokens across all applications the user is connected to. We're already
    // on the logged-out page, so a purge failure (logged by purgeTokens()
    // itself) has nowhere useful left to navigate; just swallow it here.
    return this.session.purgeTokens().catch(() => {});
  }

  // gatekeeperUri returns the uri to send users to sign in.
  @computed('environment.name')
  get gatekeeperUri() {
    return `https://${this.environment.uriPrefix}go.linc-ed.com`;
  }
}
